import React, { useState, useCallback } from "react";
import { Descriptions, Image, Card, Typography, Button } from "antd";
import { useParams, useNavigate } from "react-router-dom";
import moment from "moment";
import useApi from "../../hooks/useApi";
import { getBranch } from "../../constants/API/API";

const { Title } = Typography;

const BranchView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [branch, setBranch] = useState(null);

  useApi({
    callback: getBranch,
    payload: id,
    dependencies: [id],
    shouldCallApi: Boolean(id),
    onSuccess: (data) => {
      setBranch(data);
    },
  });

  return (
    <div className="layout-content">
      <Button type="default" className="mb-2" onClick={() => navigate(-1)}>
        Back
      </Button>

      <Card title="Branch Details">
        {branch ? (
          <>
            {branch.profilePic && (
              <div className="text-center mb-4">
                <Image
                  src={branch.profilePic}
                  alt="Branch"
                  style={{ width: 150, height: 150, borderRadius: "50%" }}
                />
              </div>
            )}
            <Descriptions bordered column={1}>
              <Descriptions.Item label="Name">{branch.name}</Descriptions.Item>
              <Descriptions.Item label="City">{branch.city?.name || "-"}</Descriptions.Item>
              <Descriptions.Item label="Address">{branch.address || "-"}</Descriptions.Item>
              <Descriptions.Item label="Details">{branch.description || "-"}</Descriptions.Item>
              <Descriptions.Item label="Status">{branch.isActive ? "Active" : "Inactive"}</Descriptions.Item>
              <Descriptions.Item label="Boutique Access">{branch.isBranchAccess ? "Yes" : "No"}</Descriptions.Item>
              <Descriptions.Item label="Created At">
                {moment(branch.createdAt).format("ll")}
              </Descriptions.Item>
              <Descriptions.Item label="Last Updated">
                {moment(branch.updatedAt).format("ll")}
              </Descriptions.Item>
            </Descriptions>
          </>
        ) : (
          <p>Loading branch details...</p>
        )}
      </Card>
    </div>
  );
};

export default BranchView;
